import React, { createContext, useContext, useMemo, useState } from "react"

export interface DetailNavigationHeaderAction {
  currentIndex: number | null
  hasNext: boolean
  hasPrevious: boolean
  itemLabel: string
  onNext: () => void
  onPrevious: () => void
  totalItems: number
  type: "detail-navigation"
}

export interface CustomHeaderAction {
  node: React.ReactNode
  type: "custom"
}

export type HeaderAction = CustomHeaderAction | DetailNavigationHeaderAction

interface HeaderActionsContextType {
  headerAction: HeaderAction | null
  setHeaderActions: (action: HeaderAction | null) => void
}

const HeaderActionsContext = createContext<
  HeaderActionsContextType | undefined
>(undefined)

interface HeaderActionsProviderProps {
  children: React.ReactNode
}

export const HeaderActionsProvider: React.FC<HeaderActionsProviderProps> = ({
  children,
}) => {
  const [headerAction, setHeaderActions] = useState<HeaderAction | null>(null)

  const value = useMemo(
    () => ({
      headerAction,
      setHeaderActions,
    }),
    [headerAction],
  )

  return (
    <HeaderActionsContext.Provider value={value}>
      {children}
    </HeaderActionsContext.Provider>
  )
}

export const useHeaderActions = (): HeaderActionsContextType => {
  const context = useContext(HeaderActionsContext)
  if (!context) {
    throw new Error(
      "useHeaderActions must be used within HeaderActionsProvider",
    )
  }
  return context
}
